import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./Contexts/AuthContext";
import { NotificationProvider } from "./Contexts/NotificationContext";
import { ChatProvider } from "./Contexts/ChatContext";
import { VocabProvider } from "./Contexts/VocabContext";
import { Toaster } from "react-hot-toast";

import AppNotificationHandler from "./Components/AppNotificationHandler";

function App() {
  useEffect(() => {
    // Ensure browser tab uses the official DIS logo
    const iconUrl = `${process.env.PUBLIC_URL || ""}/dis%20logo-32x32.png`;
    let iconEl = document.querySelector("link[rel*='icon']");
    if (!iconEl) {
      iconEl = document.createElement("link");
      iconEl.rel = "icon";
      document.head.appendChild(iconEl);
    }
    iconEl.type = "image/png";
    iconEl.href = iconUrl;
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <ChatProvider>
            <VocabProvider>
              <AppNotificationHandler />
              <AppRoutes />
              <Toaster
                position="bottom-right"
                toastOptions={{
                  duration: 5000,
                  style: {
                    borderRadius: '10px',
                    background: '#1e293b',
                    color: '#fff',
                    fontSize: '13px',
                    fontWeight: 600,
                  }
                }}
              />
            </VocabProvider>
          </ChatProvider>
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;